import {Component, OnInit} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { ImageGetNamePipe } from '../../../pipes/image-get-name.pipe';
import { SearchSelectedImage } from '../../../components/ui/search-images-list/search-images-list.component';
import { Manuscript } from '../../../models/manuscript';

@Component({
    selector: 'app-page-search-images',
    templateUrl: './page-search-images.component.html',
    styleUrls: ['./page-search-images.component.css']
})
export class PageSearchImagesComponent {
    manuscript: Manuscript;
    viewerImageUrl: SafeResourceUrl;
    expandedImage = false; // current image expansion status
    hideViewer = true; // current image viewer status

    constructor(
        private domSanitizer: DomSanitizer,
        private imageGetNamePipe: ImageGetNamePipe
    ) {
    }

    toggleImageExpansion() {
        this.expandedImage = !this.expandedImage;
    }

    loadImage($event: SearchSelectedImage) {
        if ($event.image && $event.manuscript) {
            this.manuscript = $event.manuscript;
            this.viewerImageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
                environment.endpoints.res + '/images/' + $event.image + '/viewer?'
                + 'options={"noEdit":1,"noLinks":1,"fkidmanuscripts":' + $event.manuscript.pkid
                + ',"headers":{"X-PhiBor-App":"' + environment.phiborApp + '"}}'
                + '&token=' + environment.apiKey
                + '&label=' + this.imageGetNamePipe.transform($event.image)
            );

            /* Show image viewer */
            this.hideViewer = false;

            /* Repositioning to the top of the page */
            const topElement = document.querySelector(this.expandedImage ? '#searchImageMsInfo' : '#searchImageTop');
            if (topElement) {
                topElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-search-images/page-search-images.component.ts